module.exports = __webpack_public_path__ + "static/media/points_shield.ab7c339e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/points_shield.svg
// module id = 59
// module chunks = 0